import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDrop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="drop, water, precipitation, liquid"><path d="M13.1136 2.43093C12.4758 1.85636 11.5242 1.85636 10.8864 2.43093C9.99316 3.23574 8.29125 4.87453 6.80704 6.91782C5.33753 8.94087 4 11.4703 4 14.0385C4 18.4409 7.58717 22 12 22C16.4128 22 20 18.4409 20 14.0385C20 11.4703 18.6625 8.94087 17.193 6.91782C15.7088 4.87453 14.0068 3.23574 13.1136 2.43093Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDrop;
